<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    :class="contextClassName"
  >
    <path
      d="M15 5.29297L8.2929 12.0003L15 18.7068L16.4139 17.2929L11.1207 12L16.4139 6.70689L15 5.29297Z"
    />
  </svg>
</template>

<script setup lang="ts">
  interface IProps {
    direction?: 'left' | 'right' | 'up' | 'down';
  }

  const props = withDefaults(defineProps<IProps>(), {
    direction: 'left',
  });

  const contextClassName = computed((): string => {
    return (() => {
      switch (props.direction) {
        case 'right':
          return 'rotate-180';
        case 'up':
          return 'rotate-90';
        case 'down':
          return '-rotate-90';
        default:
          return '';
      }
    })();
  });
</script>
